<section class="bug-report-dialog" aria-label="Report a bug">
  <header class="bug-report-dialog__header">
    <div>
      <p class="bug-report-dialog__eyebrow">Support</p>
      <h2>Report a bug</h2>
      <p>Tell us what happened. Drop, paste, or pick supporting files to help us reproduce it.</p>
    </div>

    <button type="button" mat-icon-button aria-label="Close bug report dialog" (click)="close()">
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </header>

  <section class="bug-report-dialog__attachments" aria-label="Attachments">
    <div class="bug-report-dialog__attachments-header">
      <div>
        <h3>Files</h3>
        <p class="bug-report-dialog__hint">Upload up to 5 files. Each file can be up to 10MB. You can drag, drop, paste, or click the zone.</p>
      </div>
    </div>

    <label
      class="bug-report-dialog__dropzone"
      [class.bug-report-dialog__dropzone--active]="isDropZoneActive()"
      tabindex="0"
      (drop)="onAttachmentDrop($event)"
      (dragover)="onAttachmentDragOver($event)"
      (dragleave)="onAttachmentDragLeave($event)"
      (paste)="onAttachmentPaste($event)"
    >
      <mat-icon aria-hidden="true">cloud_upload</mat-icon>
      <div>
        <strong>Drop files here</strong>
        <p>or paste screenshots and images directly into this area</p>
      </div>
      <span class="bug-report-dialog__dropzone-link">Choose files</span>
      <input type="file" multiple hidden (change)="onAttachmentFilesSelected($event)" />
    </label>

    @if (attachmentItems().length > 0) {
      <div class="bug-report-dialog__attachment-list">
        @for (item of attachmentItems(); track item.file.name + '-' + item.file.size + '-' + item.file.lastModified; let index = $index) {
          <div class="bug-report-dialog__attachment-item">
            <div class="bug-report-dialog__attachment-preview">
              @if (hasImagePreview(item)) {
                <img [src]="item.previewUrl" [alt]="item.file.name" />
              } @else {
                <mat-icon aria-hidden="true">description</mat-icon>
              }
            </div>
            <div class="bug-report-dialog__attachment-meta">
              <strong>{{ item.file.name }}</strong>
              <span>{{ (item.file.size / 1024 / 1024).toFixed(2) }} MB</span>
            </div>
            <button type="button" mat-button (click)="removeAttachment(index)">Remove</button>
          </div>
        }
      </div>
    }
  </section>

  <form class="bug-report-dialog__form" [formGroup]="form" (ngSubmit)="submit()" novalidate>
    <mat-form-field appearance="outline">
      <mat-label>Title (optional)</mat-label>
      <input matInput type="text" formControlName="title" />
      @if (form.controls.title.hasError('requiredEither') && form.controls.title.touched) {
        <mat-error>Add a title or description.</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Description</mat-label>
      <textarea matInput rows="3" formControlName="description"></textarea>
      @if (form.controls.description.hasError('requiredEither') && form.controls.description.touched) {
        <mat-error>Add a title or description.</mat-error>
      }
    </mat-form-field>

    <div class="bug-report-dialog__actions">
      <button type="button" mat-stroked-button color="primary" [disabled]="submitting()" (click)="close()">Cancel</button>
      <button type="submit" mat-flat-button color="primary" [disabled]="submitting()">
        @if (submitting()) {
          Submitting…
        } @else {
          Submit
        }
      </button>
    </div>
  </form>
</section>
